import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Grid,
  Snackbar,
  Alert,
  IconButton,
  Stack
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { addPermission } from "../../../store/actions/rolePermissionActions";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from 'react-router-dom';
import { BorderBottom } from "@mui/icons-material";
const PermissionManager = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const permissionData = location?.state?.permissionData;
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [permissions, setPermissions] = useState([]);
  const [initialPermissions, setInitialPermissions] = useState([]);
  // :white_check_mark: Dummy Data (can replace with API response)

  const buildTree = (list) => {
    const map = {};
    const roots = [];
    list.forEach((item) => {
      map[item.id] = { ...item, children: [] };
    });
    list.forEach((item) => {
      if (item.parentId === null) roots.push(map[item.id]);
      else if (map[item.parentId]) map[item.parentId].children.push(map[item.id]);
    });
    return roots;
  };
  useEffect(() => {
    if(permissionData?.data){
      const tree= buildTree(permissionData?.data)
      setPermissions(tree);
      setInitialPermissions(JSON.parse(JSON.stringify(tree)))
    }
  }, []);

  // Recursive toggle (downward + upward sync)
  const toggleAssigned = (node, checked) => {
    node.assigned = checked;
    if (node.children?.length > 0) {
      node.children.forEach((child) => toggleAssigned(child, checked));
    }
  };

  // :white_check_mark: Update parents upward based on children status
  const updateParentStatus = (nodes, parentId) => {
    nodes.forEach((node) => {
      if (node.id === parentId) {
        // If all children are checked → mark parent as checked
        const allChecked = node.children.every((child) => child.assigned);
        node.assigned = allChecked;
      } else if (node.children?.length > 0) {
        updateParentStatus(node.children, parentId);
        // After updating child branch, check if parent should be toggled
        const allChecked = node.children.every((child) => child.assigned);
        node.assigned = allChecked;
      }
    });
  };

  const handleToggle = (id, checked, nodes = permissions) => {
    const updated = JSON.parse(JSON.stringify(nodes));

    const updateNode = (items) => {
      items.forEach((item) => {
        if (item.id === id) {
          // Toggle current node + children
          toggleAssigned(item, checked);
        } else if (item.children?.length) {
          updateNode(item.children);
          // After updating children, adjust parent state
          const allUnchecked = item.children.every((child) => !child.assigned);
          const anyChecked = item.children.some((child) => child.assigned);
          // :white_check_mark: Parent becomes checked if any child is checked
          // :white_check_mark: Parent becomes unchecked only if all children are unchecked
          item.assigned = anyChecked ? true : false;
        }
      });
    };

    updateNode(updated);
    setPermissions(updated);
  };






  // :white_check_mark: Collect selected IDs for submission
  const getSelectedIds = (nodes) => {
    let ids = [];
    nodes.forEach((n) => {
      if (n.assigned) ids.push(n.id);
      if (n.children?.length) ids = ids.concat(getSelectedIds(n.children));
    });
    return ids;
  };
  const handleSubmit = async () => {
    const selectedIds = getSelectedIds(permissions);
    setSnack({
      open: true,
      message: "Submitting permissions...",
      severity: "info",
    });
    try {
      await dispatch(
        addPermission({
          roleId: permissionData?.details?.id,
          permissions: selectedIds,
        })
      );
      setInitialPermissions(JSON.parse(JSON.stringify(permissions)))
      setSnack({
        open: true,
        message: "Permissions updated successfully!",
        severity: "success",
      });
    } catch (error) {
      setSnack({
        open: true,
        message: "Failed to update permissions.",
        severity: "error",
      });
    }
    console.log("Selected IDs:", selectedIds);
  };

  const handleReset=()=>{
    setPermissions(JSON.parse(JSON.stringify(initialPermissions)))
    setSnack({
      open:true,
      message:"Permission reset successfully",
      severity:"info"
    })
  }
  const handleclose=()=>{
    if(JSON.stringify(permissions) !== JSON.stringify(initialPermissions)){
      const shouldStay = window.confirm(`
      You have unsaved changes.
      
      Click OK to stay on this page.
      Click Cancel to go back without saving your changes.`);

      if(shouldStay){
        return
      }else{
        history.goBack();
      }
    }else{
      history.goBack()
    }
  }
  // :white_check_mark: Recursive UI rendering
  const renderSubTree = (nodes, level = 1) =>
    nodes.map((node) => (
      <Box key={node.id} sx={{ ml: level * 2, mb: 0.5 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={node.assigned}
              onChange={(e) => handleToggle(node.id, e.target.checked)}
              size="small"
            />
          }
          label={
            <Typography
              sx={{
                fontWeight: node.action ? 400 : 500,
                textTransform: "capitalize",
              }}
            >
              {node.action
                ? node.action.replaceAll("_", " ")
                : node.category.replaceAll("_", " ")}
            </Typography>
          }
        />
        {node.children?.length > 0 && renderSubTree(node.children, level + 1)}
      </Box>
    ));

  return (
    <Box
      sx={{
        position: "absolute",
        top: 90,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#fff", // Full white background
        overflowY: "auto", // Allow scrolling
        // p: 4,
        pt:0,
        pb:4
      }}
    >
      <Box sx={{ position:"sticky",top:0, zIndex:10,backgroundColor:"#E4EEFA" ,BorderBottom:"1px solid #e0e0e0", display:"flex",alignItems:"center",justifyContent:"space-between",py:1,mb:2}}>
        <Box sx={{width:40}}/>
      <Typography variant="h5" sx={{flex:1,textAlign:"center"}}>
        {permissionData?.details?.type === "Role"
          ? `Manage Permissions for ${permissionData?.details?.name || "Unknown Role"}`
          : `View permission for ${permissionData?.details?.type} : ${permissionData?.details?.name || "Unknown Role"} (${permissionData?.details?.roleName || "Unknown Role"})`}
      </Typography>
      <IconButton sx={{mr:2}} onClick={handleclose}><CloseIcon/></IconButton>
      </Box>

      <Grid container spacing={4}>
        {permissions.map((category) => (
          <Grid item xs={12} sm={6} lg={3} key={category.id}>
            <Box sx={{ height: "100%", p: 2 }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  textTransform: "capitalize",
                }}
              >
                {category.category.replaceAll("_", " ")}
              </Typography>
              <FormGroup>{renderSubTree(category.children || [])}</FormGroup>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* {permissionData?.details?.type !== "User" && (
        <Box sx={{ mt: 4 }}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      )} */}
      {/* ---------- Footer Buttons ---------- */}
      {permissionData?.details?.type !== "User" && (
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          sx={{ mt: 4 }}
        >
          <Button variant="contained" onClick={handleSubmit} disabled={JSON.stringify(permissions) === JSON.stringify(initialPermissions)}>
            Submit
          </Button>
          <Button variant="outlined" onClick={handleReset}disabled={JSON.stringify(permissions) === JSON.stringify(initialPermissions)}>
            Reset
          </Button>
          {/* <Button
            variant="outlined"
            onClick={() => history.goBack()}
          >
            Cancel
          </Button> */}
        </Stack>
      )}

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default PermissionManager;
